export const game_question_answer = require("./question_answer.png");
export const question_answermask = require("./question_answermask.png");
export const game_home_title = require("./game_home_title.png");
export const question_backgrounk = require("./question_backgrounk.png");
export const game_success = require("./game_success.png");
export const game_warn = require("./game_warn.png");
export const game_toast_warn = require("./game_toast_warn.png");
export const game_toast_success = require("./game_toast_success.png");
export const game_share_toast = require("./game_share_toast.png");

export const question_fail = require("./question_fail.png");
export const question_countdown = require("./question_countdown.png");
export const wait_fail = require("./wait_fail.png");
export const question_success = require("./question_success.png");
export const question_warn = require("./question_warn.png");
export const game_rank_0 = require("./game_rank_0.png");
export const game_rank_1 = require("./game_rank_1.png");
export const game_rank_2 = require("./game_rank_2.png");
export const game_rank_title = require("./game_rank_title.png");
export const game_publicity_title = require("./game_publicity_title.png");
export const game_result_bg = require("./game_result_bg.png");
export const game_exceed_time = require("./game_exceed_time.png");
export const game_result_fail_icon = require("./game_result_fail_icon.png");
export const game_result_fail = require("./game_result_fail.png");
export const game_result_info = require("./game_result_info.png");
export const game_result_qr = require("./game_result_qr.png");
export const game_result_success_icon = require("./game_result_success_icon.png");
export const game_result_success = require("./game_result_success.png");
export const game_result_week_icon = require("./game_result_week_icon.png");
export const game_share_logo = require("./game_share_logo.png");
export const game_share_qr = require("./game_share_qr.png");
export const game_slogan_success = require("./game_slogan_success.png");
export const game_slogan_fail = require("./game_slogan_fail.png");




